import {createIcons, icons, type IconNode, type SVGProps} from 'lucide';

import {initBootstrapTooltips} from './bootstrap';

/**
 * Custom raster logo icon (not in the Lucide set). Register only here —
 * do not put data-lucide="nais-logo" in Latte; use a normal Lucide name
 * (e.g. settings). createIcons emits class="lucide lucide-nais-logo".
 *
 * Inner node must be an explicit [tag, attrs] tuple — a nested array literal
 * widens to (string | object)[] and fails IconNode assignability under tsc/IDE.
 */
const naisLogoNode: [string, SVGProps] = [
    'image',
    {
        href: '/backend/images/default-logo-small.jpg',
        width: '24',
        height: '24',
        x: '0',
        y: '0',
        preserveAspectRatio: 'xMidYMid meet',
    },
];
const NaisLogo: IconNode = [naisLogoNode];

/**
 * Markup: <i data-lucide="settings" aria-hidden="true"></i>
 * Re-run after Nette AJAX snippet updates.
 */
export function initLucideIcons(root: ParentNode = document): void {
    createIcons({
        icons: {...icons, NaisLogo},
        root: root instanceof Element ? root : document.documentElement,
        attrs: {
            'stroke-width': 2,
        },
    });

    // Lucide replaces each icon host with a new SVG node. Rebind Bootstrap
    // tooltips to that final node instead of leaving them on the detached host.
    initBootstrapTooltips(root);
}

/** For plain JS modules (e.g. sideDialog.js) that create Lucide hosts dynamically. */
window.initLucideIcons = initLucideIcons;
